import CreateSetupBackend from "../config/config.js";

let SetupBackend = null;

function createTed(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post("/v1/pix/cashout/withdrawalted", data);
}

function showTedStatus(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(`/v1/ted/showtedstatus?id=${data.id}`);
}

const backendServices = {
  createTed,
  showTedStatus,
};

export default backendServices;
